import { PageLoading } from 'components/loading'
import { useAtendimentoViewQuery } from 'graphql/hooks.generated'
import { useParams } from 'react-router'

import { AtendimentoVacinacaoBaseView } from './AtendimentoVacinacaoBaseView'

interface AtendimentoVacinacaoViewParams {
  atendimentoId: ID
}

export const AtendimentoVacinacaoRootView = () => {
  const { atendimentoId } = useParams<AtendimentoVacinacaoViewParams>()

  const {
    data: { atendimento },
    loading,
  } = useAtendimentoViewQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      id: atendimentoId,
    },
  })

  if (loading) {
    return <PageLoading message='Carregando atendimento...' />
  }

  return <AtendimentoVacinacaoBaseView atendimento={atendimento} />
}
